<template>
    <div>
        <div v-show="isDataTableLoading === false">
            <template v-if="topupPayment">
                <div class="page-top mb-1 mb-3 align-left clearfix">
                    <h1> Topup Payments</h1>
                </div>
                <a href="javascript:void(0)" data-toggle="modal" data-target="#newBatchModal" class="btn btn-primary float-right" v-if="uploadTopupButton == true"> New Batch </a>
                <!-- New Batch Modal -->
                <div class="modal fade" id="newBatchModal" tabindex="-1" role="dialog" aria-labelledby="newBatchModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="modal-body new-batch-popup">
                                <div class="popup-head line-head mt-4 mb-5">
                                    <h2 class="pb-3"> Select Payment Type </h2>
                                </div>
                                <div class="new-batch-boxes-holder">
                                    <div class="row">
                                        <div class="col">
                                            <div class="batch-box" :class="{ 'active': tick_active == true}">
                                                <div class="spin-tick">
                                                    <div class="add-spin"></div>
                                                    <img src="/images/svgs/new-batch-tick.svg" class="tick-check" alt="" />
                                                </div>
                                                <span @click="proceedToGenerateBatch">
                                                    <img src="/images/topup-icon2.png" alt="" />
                                                    <p> Bulk Topup </p>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="batch-box" :class="{ 'active': tick_active == true}">
                                                <div class="spin-tick">
                                                    <div class="add-spin"></div>
                                                    <img src="/images/svgs/new-batch-tick.svg" class="tick-check" alt="" />
                                                </div>
                                                <span @click="proceedToIndividualTopup">
                                                    <img src="/images/topup-icon1.png" alt="" />
                                                    <p> Individual Topup </p>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-top mb-1 mb-3 clearfix">
                    <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="new-tab" data-toggle="tab" href="#new" role="tab"
                                aria-controls="new" aria-selected="true" @click="reloadList('new')">New
                                ({{new_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="inprocess-tab" data-toggle="tab" href="#inprocess" role="tab"
                                aria-controls="inprocess" aria-selected="false" @click="reloadList('inprocess')">In Process
                                ({{inprocess_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="processed-tab" data-toggle="tab" href="#processed" role="tab"
                                aria-controls="processed" aria-selected="false" @click="reloadList('processed')">Processed
                                ({{processed_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="error-tab" data-toggle="tab" href="#error" role="tab"
                                aria-controls="error" aria-selected="false" @click="reloadList('error')">Error
                                ({{error_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="disapproved-tab" data-toggle="tab" href="#disapproved" role="tab"
                                aria-controls="disapproved" aria-selected="false"
                                @click="reloadList('disapproved')">Disapproved ({{disapproved_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="delete-tab" data-toggle="tab" href="#delete" role="tab"
                                aria-controls="delete" aria-selected="false" @click="reloadList('deleted')">Deleted
                                ({{delete_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="archived-tab" data-toggle="tab" href="#archived" role="tab"
                                aria-controls="archived" aria-selected="false" @click="reloadList('archived')">Archived
                                ({{archived_batch_count}})</a>
                        </li>
                    </ul>

                    <!-- <router-link to="/topupBulkUpload"  class="btn btn-primary float-right mr-1" v-if="uploadTopupButton == true"> New Batch </router-link> -->
                </div>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                        <table id="dt-new" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Time Period</th>
                                    <th>Amount </th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="inprocess" role="tabpanel" aria-labelledby="inprocess-tab">
                        <table id="dt-inprocess" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Time Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="processed" role="tabpanel" aria-labelledby="processed-tab">
                        <table id="dt-processed" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Time Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="error" role="tabpanel" aria-labelledby="error-tab">
                        <table id="dt-error" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Time Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="disapproved" role="tabpanel" aria-labelledby="disapproved-tab">
                        <table id="dt-disapproved" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Time Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="delete" role="tabpanel" aria-labelledby="delete-tab">
                        <table id="dt-delete" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Time Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="archived" role="tabpanel" aria-labelledby="archived-tab">
                        <table id="dt-archived" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Time Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </template>
            <template v-if="topupPayment == null">
                <preLoader />
            </template>
            <template v-if="topupPayment == false">
                <notAllowed></notAllowed>
            </template>
        </div>
        <preLoader v-show="isDataTableLoading === true"></preLoader>
    </div>
</template>
<script>
    var gThat = null;
    export default {
        data() {
            return {
                data : null,
                topupPayment: null,
                addTopupPayment:null,
                new_batch_count : '',
                inprocess_batch_count : '',
                processed_batch_count : '',
                error_batch_count: '',
                disapproved_batch_count:'',
                delete_batch_count : '',
                archived_batch_count : '',
                uploadTopupButton:false,
                tick_active : false,
                currentActiveTab : 'new',
                isDataTableLoading : false,
                dtNewTPayments : null,
                dtInProcessTPayments : null,
                dtProcessedTPayments : null,
                dtArchivedTPayments : null,
                dtErrorTPayments : null,
                dtDeleteTPayments : null,
                dtDisapprovedTPayments : null,
            };
        },
        mounted() {
            gThat = this;

            this.$Progress.start();
            this.can('topup_payments|add_topup_payment').then(result => {

                this.topupPayment = result.topup_payments;
                this.addTopupPayment = result.add_topup_payment;
            }).then(result => {

                if(this.topupPayment == true){
                    this.newList();
                    this.inProcessList();
                    this.processList();
                    this.errorList();
                    this.disapprovedList();
                    this.deleteList();
                    this.archivedList();
                    if(this.addTopupPayment == true){
                       this.uploadTopupButton = true;
                    }
                }
            });
        },
        methods: {
            proceedToIndividualTopup: function(){
				this.tick_active = true;
				setTimeout(() => {
					$('#newBatchModal').modal('hide');
					this.$router.push('/topupIndividualUpload');
				}, 1000);
			},
            proceedToGenerateBatch: function(){
                this.tick_active = true;
                setTimeout(() => {
                    $('#newBatchModal').modal('hide');
                    this.$router.push('/topupBulkUpload');
                }, 1000);
            },
            newList: function(){
                gThat.dtNewTPayments = $('#dt-new').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getTopupPaymentNewList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "data",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {
                            data: 'sName',"mData": "sName",'mRender':function(data,type,full){
                                var id = full['bId'];
                                var title = full['sName'];
                                var url = '/viewTopupSheet/'+id;
                                var  to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+url+'\')">'+title+'</a>';
                            return to_return;
                        }},

                        {data: 'created',"mData": "created",'mRender':function(data,type,full){
                        var date = new Date(full['created']);
                        return moment(date).format('MMM D, Y');
                        }},
                        {"name":"timeperiod","mData": "timeperiod","orderable":false,
                        "mRender": function (data, type, full) {
                             var date = new Date(full['created']);
                             return moment(date).format('MMM D, Y');
                           }
                        },
                        {"name":"amount","mData": "amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"pStatus","mData": "pStatus","mRender":function(data,type,full){
                            var status = full['pStatus'];
                            if(status == 1){
                                var to_return = '<span class="status uploaded">Uploaded </span>'
                            }else if(status == 2){
                                var to_return = '<span class="status uploaded">Under Review </span>'
                            }else if(status == 3){
                                var to_return = '<span class="status checked"> Checked </span>'
                            }else if(status == 4){
                                var to_return = '<span class="status proccessing">Partial  </span>'
                            }else if(status == 5){
                                var to_return = '<span class="status processed"> Processed </span>'
                            }else if(status == 6){
                                var to_return = '<span class="status disapproved">Disapproved </span>'
                            }else if(status == 7){
                                var to_return = '<span class="status flagged"> Flagged </span>'
                            }else if(status == 8){
                                var to_return = '<span class="status">Archive  </span>'
                            }else if(status == 10){
                                var to_return = '<span class="status proccessing"> Processing </span>'
                                }
                            else if(status == 11){
                                var to_return = '<span class="status error  "> Error </span>'
                            }else if(status == 21){
                                var to_return = '<span class="status flagged">Deleted  </span>'
                            }
                            var canEdit = full['canEdit'];
                            var status = full['pStatus'];
                            var id = full['bId'];
                            var userUrl = '/viewTopupSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['bId'];
                        var $url = '/viewTopupSheet/'+id;

                             return'<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +$url +'\')" class="view"><span class="status processing"> Process </span></a></td>';},
                        visible: gThat.crud_region},
                            ],
                       "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => { this.new_batch_count = json.recordsTotal; }
                });
            },
            inProcessList: function(){
                gThat.dtInProcessTPayments = $('#dt-inprocess').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getTopupPaymentInProcessList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "data",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'sName',"mData": "sName",'mRender':function(data,type,full){
                        var id = full['bId'];
                        var title = full['sName'];
                        var url = '/viewTopupSheet/'+id;
                        var  to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+url+'\')">'+title+'</a>';
						return to_return;
                        }},
                        {data: 'created',"mData": "created",'mRender':function(data,type,full){
                        var date = new Date(full['created']);
                        return moment(date).format('MMM D, Y');
                        }},
                        {"name":"timeperiod","mData": "timeperiod","orderable":false,
                        "mRender": function (data, type, full) {
                         var date = new Date(full['created']);
                         return moment(date).format('MMM D, Y');
                        }
                        },
                        {"name":"amount","mData": "amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"pStatus","mData": "pStatus","mRender":function(data,type,full){
                            var status = full['pStatus'];
                             if(status == 1){
                                var to_return = '<span class="status uploaded">Uploaded </span>'
                            }else if(status == 2){
                                var to_return = '<span class="status uploaded">Under Review </span>'
                            }else if(status == 3){
                                var to_return = '<span class="status checked"> Checked </span>'
                            }else if(status == 4){
                                var to_return = '<span class="status proccessing">Partial  </span>'
                            }else if(status == 5){
                                var to_return = '<span class="status processed"> Processed </span>'
                            }else if(status == 6){
                                var to_return = '<span class="status disapproved">Disapproved </span>'
                            }else if(status == 7){
                                var to_return = '<span class="status flagged"> Flagged </span>'
                            }else if(status == 8){
                                var to_return = '<span class="status">Archive  </span>'
                            }else if(status == 10){
                                var to_return = '<span class="status proccessing"> Processing </span>'
                                }
                            else if(status == 11){
                                var to_return = '<span class="status error  "> Error </span>'
                            }else if(status == 21){
                                var to_return = '<span class="status flagged">Deleted  </span>'
                            }
                            var canEdit = full['canEdit'];
                            var status = full['pStatus'];
                            var id = full['bId'];
                            var userUrl = '/viewTopupSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['bId'];
                        var $url = '/viewTopupSheet/'+id;
                             return'<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';},
                        visible: gThat.crud_region},
                            ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => { this.inprocess_batch_count = json.recordsTotal; }
                });
            },
            processList: function(){
                gThat.dtProcessedTPayments = $('#dt-processed').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getTopupPaymentProcessedList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "data",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'sName',"mData": "sName",'mRender':function(data,type,full){
                        var id = full['bId'];
                        var title = full['sName'];
                        var url = '/viewTopupSheet/'+id;
                        var  to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+url+'\')">'+title+'</a>';
						return to_return;
                        }},
                        {data: 'created',"mData": "created",'mRender':function(data,type,full){
                        var date = new Date(full['created']);
                        return moment(date).format('MMM D, Y');
                        }},
                        {"name":"timeperiod","mData": "timeperiod","orderable":false,
                        "mRender": function (data, type, full) {
                          var date = new Date(full['created']);
                          return moment(date).format('MMM D, Y');
                        }
                        },
                        {"name":"amount","mData": "amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"pStatus","mData": "pStatus","mRender":function(data,type,full){
                            var status = full['pStatus'];
                            if(status == 1){
                                var to_return = '<span class="status uploaded">Uploaded </span>'
                            }else if(status == 2){
                                var to_return = '<span class="status uploaded">Under Review </span>'
                            }else if(status == 3){
                                var to_return = '<span class="status checked"> Checked </span>'
                            }else if(status == 4){
                                var to_return = '<span class="status proccessing">Partial  </span>'
                            }else if(status == 5){
                                var to_return = '<span class="status processed"> Processed </span>'
                            }else if(status == 6){
                                var to_return = '<span class="status disapproved">Disapproved </span>'
                            }else if(status == 7){
                                var to_return = '<span class="status flagged"> Flagged </span>'
                            }else if(status == 8){
                                var to_return = '<span class="status">Archive  </span>'
                            }else if(status == 10){
                                var to_return = '<span class="status proccessing"> Processing </span>'
                                }
                            else if(status == 11){
                                var to_return = '<span class="status error  "> Error </span>'
                            }else if(status == 21){
                                var to_return = '<span class="status flagged">Deleted  </span>'
                            }
                            var canEdit = full['canEdit'];
                            var status = full['pStatus'];
                            var id = full['bId'];
                            var userUrl = '/viewTopupSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['bId'];
                        var $url = '/viewTopupSheet/'+id;
                             return'<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';},
                        visible: gThat.crud_region},
                        ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => { this.processed_batch_count = json.recordsTotal; }
                });
            },
            archivedList:function(){
                gThat.dtArchivedTPayments = $('#dt-archived').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getTopupPaymentArchivedList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "data",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.$Progress.finish();
                            }
                        }
                    },
                     deferRender: true,
                      columns: [
                        {data: 'sName',"mData": "sName",'mRender':function(data,type,full){
                        var id = full['bId'];
                        var title = full['sName'];
                        var url = '/viewTopupSheet/'+id;
                        var  to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+url+'\')">'+title+'</a>';
						return to_return;
                        }},
                        {data: 'created',"mData": "created",'mRender':function(data,type,full){
                        var date = new Date(full['created']);
                        return moment(date).format('MMM D, Y');
                        }},
                        {"name":"timeperiod","mData": "timeperiod","orderable":false,
                        "mRender": function (data, type, full) {
                            var date = new Date(full['created']);
                            return moment(date).format('MMM D, Y');
                        }
                        },
                           {"name":"amount","mData": "amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"pStatus","mData": "pStatus","mRender":function(data,type,full){
                            var status = full['pStatus'];
                             if(status == 1){
                                var to_return = '<span class="status uploaded">Uploaded </span>'
                            }else if(status == 2){
                                var to_return = '<span class="status uploaded">Under Review </span>'
                            }else if(status == 3){
                                var to_return = '<span class="status checked"> Checked </span>'
                            }else if(status == 4){
                                var to_return = '<span class="status proccessing">Partial  </span>'
                            }else if(status == 5){
                                var to_return = '<span class="status processed"> Processed </span>'
                            }else if(status == 6){
                                var to_return = '<span class="status disapproved">Disapproved </span>'
                            }else if(status == 7){
                                var to_return = '<span class="status flagged"> Flagged </span>'
                            }else if(status == 8){
                                var to_return = '<span class="status">Archive  </span>'
                            }else if(status == 10){
                                var to_return = '<span class="status proccessing"> Processing </span>'
                            }
                            else if(status == 11){
                                var to_return = '<span class="status error  "> Error </span>'
                            }else if(status == 21){
                                var to_return = '<span class="status flagged">Deleted  </span>'
                            }
                            var canEdit = full['canEdit'];
                            var status = full['pStatus'];
                            var id = full['bId'];
                            var userUrl = '/viewTopupSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                         {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['bId'];

                        var $url = '/viewTopupSheet/'+id;

                        return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';},
                        visible: gThat.crud_region},
                            ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => { this.archived_batch_count = json.recordsTotal; }
                });
            },
            errorList:function(){ //error
                gThat.dtErrorTPayments = $('#dt-error').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getTopupPaymentErrorList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "data",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.$Progress.finish();
                            }
                        }
                    },
                     deferRender: true,
                      columns: [
                        {data: 'sName',"mData": "sName",'mRender':function(data,type,full){
                        var id = full['bId'];
                        var title = full['sName'];
                        var url = '/viewTopupSheet/'+id;
                        var  to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+url+'\')">'+title+'</a>';
						return to_return;
                        }},
                        {data: 'created',"mData": "created",'mRender':function(data,type,full){
                        var date = new Date(full['created']);
                        return moment(date).format('MMM D, Y');
                        }},
                        {"name":"timeperiod","mData": "timeperiod","orderable":false,
                        "mRender": function (data, type, full) {
                          var date = new Date(full['created']);
                          return moment(date).format('MMM D, Y');
                        }
                        },
                           {"name":"amount","mData": "amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"pStatus","mData": "pStatus","mRender":function(data,type,full){
                            var status = full['pStatus'];
                             if(status == 1){
                                var to_return = '<span class="status uploaded">Uploaded </span>'
                            }else if(status == 2){
                                var to_return = '<span class="status uploaded">Under Review </span>'
                            }else if(status == 3){
                                var to_return = '<span class="status checked"> Checked </span>'
                            }else if(status == 4){
                                var to_return = '<span class="status proccessing">Partial  </span>'
                            }else if(status == 5){
                                var to_return = '<span class="status processed"> Processed </span>'
                            }else if(status == 6){
                                var to_return = '<span class="status disapproved">Disapproved </span>'
                            }else if(status == 7){
                                var to_return = '<span class="status flagged"> Flagged </span>'
                            }else if(status == 8){
                                var to_return = '<span class="status">Archive  </span>'
                            }
                            else if(status == 10){
                                var to_return = '<span class="status proccessing"> Processing </span>'
                                }
                            else if(status == 11){
                                var to_return = '<span class="status error  "> Error </span>'
                            }else if(status == 21){
                                var to_return = '<span class="status flagged">Deleted  </span>'
                            }
                            var canEdit = full['canEdit'];
                            var status = full['pStatus'];
                            var id = full['bId'];
                            var userUrl = '/viewTopupSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                         {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['bId'];

                        var $url = '/viewTopupSheet/'+id;

                        return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';},
                        visible: gThat.crud_region},
                            ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => { this.error_batch_count = json.recordsTotal; }
                });
            },
            deleteList: function(){
                gThat.dtDeleteTPayments = $('#dt-delete').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getTopupPaymentDeleteList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "data",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'sName',"mData": "sName",'mRender':function(data,type,full){
                        var id = full['bId'];
                        var title = full['sName'];
                        var url = '/viewTopupSheet/'+id;
                        var  to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+url+'\')">'+title+'</a>';
						return to_return;
                        }},
                        {data: 'created',"mData": "created",'mRender':function(data,type,full){
                        var date = new Date(full['created']);
                        return moment(date).format('MMM D, Y');
                        }},
                        {"name":"timeperiod","mData": "timeperiod","orderable":false,
                        "mRender": function (data, type, full) {
                            var date = new Date(full['created']);
                             return moment(date).format('MMM D, Y');
                        }
                        },
                        {"name":"amount","mData": "amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"pStatus","mData": "pStatus","mRender":function(data,type,full){
                            var status = full['pStatus'];
                             if(status == 1){
                                var to_return = '<span class="status uploaded">Uploaded </span>'
                            }else if(status == 2){
                                var to_return = '<span class="status uploaded">Under Review </span>'
                            }else if(status == 3){
                                var to_return = '<span class="status checked"> Checked </span>'
                            }else if(status == 4){
                                var to_return = '<span class="status proccessing">Partial  </span>'
                            }else if(status == 5){
                                var to_return = '<span class="status processed"> Processed </span>'
                            }else if(status == 6){
                                var to_return = '<span class="status disapproved">Disapproved </span>'
                            }else if(status == 7){
                                var to_return = '<span class="status flagged"> Flagged </span>'
                            }else if(status == 8){
                                var to_return = '<span class="status">Archive  </span>'
                            }else if(status == 10){
                                var to_return = '<span class="status proccessing"> Processing </span>'
                                }
                            else if(status == 11){
                                var to_return = '<span class="status error  "> Error </span>'
                            }else if(status == 21){
                                var to_return = '<span class="status flagged">Deleted  </span>'
                            }
                            var canEdit = full['canEdit'];
                            var status = full['pStatus'];
                            var id = full['bId'];
                            var userUrl = '/viewTopupSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['bId'];
                        var $url ='/viewTopupSheet/'+id;

                            return'<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';},
                        visible: gThat.crud_region},
                            ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => { this.delete_batch_count = json.recordsTotal; }
                });
            },
            disapprovedList: function(){
                gThat.dtDisapprovedTPayments = $('#dt-disapproved').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getTopupPaymentDisapprovedList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "data",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'sName',"mData": "sName",'mRender':function(data,type,full){
                        var id = full['bId'];
                        var title = full['sName'];
                        var url = '/viewTopupSheet/'+id;
                        var  to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+url+'\')">'+title+'</a>';

						return to_return;
                        }},
                        {data: 'created',"mData": "created",'mRender':function(data,type,full){
                        var date = new Date(full['created']);
                        return moment(date).format('MMM D, Y');
                        }},
                        {"name":"timeperiod","mData": "timeperiod","orderable":false,
                        "mRender": function (data, type, full) {
                            var date = new Date(full['created']);
                             return moment(date).format('MMM D, Y');
                        }},
                        {"name":"amount","mData": "amount","render": $.fn.dataTable.render.number(',')},
                        {"name":"pStatus","mData": "pStatus","mRender":function(data,type,full){
                            var status = full['pStatus'];
                              if(status == 1){
                                var to_return = '<span class="status uploaded">Uploaded </span>'
                            }else if(status == 2){
                                var to_return = '<span class="status uploaded">Under Review </span>'
                            }else if(status == 3){
                                var to_return = '<span class="status checked"> Checked </span>'
                            }else if(status == 4){
                                var to_return = '<span class="status proccessing">Partial  </span>'
                            }else if(status == 5){
                                var to_return = '<span class="status processed"> Processed </span>'
                            }else if(status == 6){
                                var to_return = '<span class="status disapproved">Disapproved </span>'
                            }else if(status == 7){
                                var to_return = '<span class="status flagged"> Flagged </span>'
                            }else if(status == 8){
                                var to_return = '<span class="status">Archive  </span>'
                            }else if(status == 10){
                                var to_return = '<span class="status proccessing"> Processing </span>'
                                }
                            else if(status == 11){
                                var to_return = '<span class="status error"> Error </span>'
                            }else if(status == 21){
                                var to_return = '<span class="status flagged">Deleted  </span>'
                            }
                            var canEdit = full['canEdit'];
                            var status = full['pStatus'];
                            var id = full['bId'];
                            var userUrl = '/viewTopupSheet/'+id;

                            to_return = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+userUrl+'\')">'+to_return+'</a>';
                            return to_return;

                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                        var id = full['bId'];
                        var $url = '/viewTopupSheet/'+id;

                       // return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" >view sheet</a>';},
                           return'<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action edit"> <i class="far fa-eye"></i> </a></td>';
                           },
                        visible: gThat.crud_region},
                        // {data: 'id', sorting: false, render: function(data,type,full){
						// 		var $url = '/viewEmployeePaymentBatchSheet/'+full['bId'];
						// 		return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="far fa-eye"></i> </a></td>';
						// 	}},
                            ],
                     "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => { this.disapproved_batch_count = json.recordsTotal; }
                });
            },
            reloadList(tabClicked){

                switch(tabClicked)
                {
                    case 'new':
                        if(gThat.currentActiveTab !== 'new')
                        {
                            gThat.isDataTableLoading = true;

                            gThat.dtNewTPayments.ajax.reload(function(json){
                                gThat.new_batch_count 	    = json.recordsTotal;
                                gThat.isDataTableLoading 	= false;
                            }, false);

                            gThat.currentActiveTab = 'new';	
                        }
                    break;

                    case 'inprocess':
                        if(gThat.currentActiveTab !== 'inprocess')
                        {
                            gThat.isDataTableLoading = true;

                            gThat.dtInProcessTPayments.ajax.reload(function(json){
                                gThat.inprocess_batch_count 	= json.recordsTotal;
                                gThat.isDataTableLoading 		= false;
                            }, false);

                            gThat.currentActiveTab = 'inprocess';
                        }
                    break;

                    case 'processed':
                        if(gThat.currentActiveTab !== 'processed')
                        {
                            gThat.isDataTableLoading = true;

                            gThat.dtProcessedTPayments.ajax.reload(function(json){
                                gThat.processed_batch_count 	= json.recordsTotal;
                                gThat.isDataTableLoading 		= false;
                            }, false);

                            gThat.currentActiveTab = 'processed';
                        }
                    break;

                    case 'disapproved':
                        if(gThat.currentActiveTab !== 'disapproved')
                        {
                            gThat.isDataTableLoading = true;

                            gThat.dtDisapprovedTPayments.ajax.reload(function(json){
                                gThat.disapproved_batch_count = json.recordsTotal;
                                gThat.isDataTableLoading 	  = false;
                            }, false);

                            gThat.currentActiveTab = 'disapproved';
                        }
                    break;

                    case 'error':
                        if(gThat.currentActiveTab !== 'error')
                        {
                            gThat.isDataTableLoading = true;

                            gThat.dtErrorTPayments.ajax.reload(function(json){
                                gThat.error_batch_count 		= json.recordsTotal;
                                gThat.isDataTableLoading 		= false;
                            }, false);

                            gThat.currentActiveTab = 'error';
                        }
                    break;

                    case 'archived':
                        if(gThat.currentActiveTab !== 'archived')
                        {
                            gThat.isDataTableLoading = true;

                            gThat.dtArchivedTPayments.ajax.reload(function(json){
                                gThat.archived_batch_count = json.recordsTotal;
                                gThat.isDataTableLoading   = false;
                            }, false);

                            gThat.currentActiveTab = 'archived';
                        }
                    break;

                    case 'deleted':
                        if(gThat.currentActiveTab !== 'deleted')
                        {
                            gThat.isDataTableLoading = true;

                            gThat.dtDeleteTPayments.ajax.reload(function(json){
                                gThat.delete_batch_count 	= json.recordsTotal;
                                gThat.isDataTableLoading 	= false;
                            }, false);

                            gThat.currentActiveTab = 'deleted';
                        }
                    break;
                }
            }
        },
    }
</script>
